import React from 'react';
import { graphql } from 'react-apollo';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import SEARCH_ARTISTS_QUERY from '../../../graphql/SearchArtists';
import SearchBar from '../../../components/SearchBar/index';
import ArtistsGrid from '../../../components/Artists/ArtistsGrid';
import KeyToProfession from '../../../transforms/KeyToProfession';

const TABLE = 'table';
const CARDS = 'cards';

class SearchArtists extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showType: localStorage.getItem('escenaArtistsView') || CARDS,
    };
  }
  onSearch = (terms) => {
    this.props.history.push({
      pathname: '/search/artists',
      state: terms,
    });
  };

  setViewType = (type) => {
    localStorage.setItem('escenaArtistsView', type);
    window.location.href = '/search/artists';
  };

  seeArtist = cell => (
    <div>
      <a href={`/artist/${cell}`}>Ver ficha</a>
    </div>
  );

  render() {
    const { showType } = this.state;

    const artistsTransformed = this.props.artists.map((a) => {
      a.completename = `${a.name} ${a.lastname}`;
      a.shortDesc = `${KeyToProfession(a.profession)} ${a.specialty && `- ${a.specialty}`}`;
      return a;
    });

    const childElementsTable = (
      <BootstrapTable data={artistsTransformed || []} striped hover>
        <TableHeaderColumn isKey dataField="id" dataSort hidden>
          ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="completename">Nombre</TableHeaderColumn>
        <TableHeaderColumn
          dataField="shortDesc"
        >
          Especialidad
        </TableHeaderColumn>
        <TableHeaderColumn dataField="nationality">
          País
        </TableHeaderColumn>
        <TableHeaderColumn dataFormat={this.seeArtist} dataField="slug">
          Acciones
        </TableHeaderColumn>
      </BootstrapTable>
    );
    return (
      <div>
        <Banner />
        <div className="recent-properties">
          <div className="container">
            <div className="main-title">
              <h1>Resultados búsqueda</h1>
              <div className="border">
                <div className="border-inner" />
              </div>
            </div>
            <div className="row mb-40">
              <SearchBar onSearch={this.onSearch} artists />
            </div>
            <div className="row mb-40 grid-buttons">
              Ver:&nbsp;&nbsp;
              <buton
                onClick={() => this.setViewType(TABLE)}
                onKeyDown={() => this.setViewType(TABLE)}
              >
                <i
                  className={`fa fa-list ${showType === TABLE ? 'active' : ''}`}
                />
              </buton>
              <buton
                onClick={() => this.setViewType(CARDS)}
                onKeyDown={() => this.setViewType(CARDS)}
              >
                <i
                  className={`fa fa-th ${showType === CARDS ? 'active' : ''}`}
                />
              </buton>
            </div>
            {this.props.artists ? (
              <div>
                <h3>Artistas</h3>
                <i>({this.props.artists.length} resultados)</i>
                {
                  showType === CARDS &&
                (<ArtistsGrid
                  limit
                  limitTo={3}
                  showMore
                  artists={this.props.artists}
                />)
              }
                {
                showType === TABLE && (
                  childElementsTable
                )
              }
              </div>
            ) : (
              <div />
            )}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withSearchResults = graphql(SEARCH_ARTISTS_QUERY, {
  options: ({ location }) => ({
    variables: location.state,
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    artists: data.searchArtists ? data.searchArtists.artists : [],
  }),
});
export default withSearchResults(SearchArtists);



// WEBPACK FOOTER //
// ./src/containers/Search/Artists/index.js